var map = {
	"./modules/global.js": "sxIo",
	"./modules/home.js": "TJLE",
	"./modules/login.js": "Pjh6",
	"./modules/network.js": "bvKG",
	"./modules/order.js": "Ly3b",
	"./modules/role.js": "HqZ+",
	"./modules/shop.js": "zefy",
	"./modules/system.js": "7XB6",
	"./modules/user.js": "6egg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "k68d";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh-cn ^\.\/modules\/([\s\S])+\.js$
// module id = k68d
// module chunks = 12